import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import TitleContent from '../TitleContent';
import Search from '../Search';
import { ContainedLoader } from '../Loader';
import CardItem from './cardItem';
import './index.scss';

class GuidesListing extends Component {
  state = { valueSearch: '' };

  changeIconOut = () => this.setState({ valueSearch: '' });

  handleChange = valueSearch => {
    const valueTyped = valueSearch.target.value
      .toLowerCase()
      .replace(/(?:^|\s)\S/g, a => a.toUpperCase());

    this.setState({ valueSearch: valueTyped });
  };

  filterByBenefName = gto =>
    gto.beneficiary.nomeBenef.toLowerCase().includes(this.state.valueSearch.toLowerCase());

  filterByOrcamento = gto => gto.gtoId.toString().includes(this.state.valueSearch);

  renderCardItem = item => <CardItem card={item} key={item.gtoId} />;

  render() {
    const { valueSearch } = this.state;
    const { gtosList, loading, error } = this.props;

    return loading ? (
      <ContainedLoader />
    ) : (
        <div className="guides-listing">
          <Search
            placeholder="Pesquisar GTO"
            valueSearch={valueSearch}
            handleChange={this.handleChange}
            changeIconOut={this.changeIconOut}
          />

          <TitleContent color="blue" text="GTOs Glosadas" />

          {!gtosList.length && !error && (
            <div style={{ marginTop: 25 }}>
              <div className="boxEmpty">
                <div className="empty" />
                <p>A lista está vazia</p>
              </div>
            </div>
          )}

          {error && (
            <Fragment>
              <div className="boxEmpty">
                <div className="empty" />
                <p>Não foi possível trazer a lista de glosa</p>
              </div>
              <ToastContainer />
            </Fragment>
          )}

          {gtosList.length && valueSearch.length > 0 ? (
            <ul className="list">
              {gtosList
                .filter(gto => this.filterByBenefName(gto) || this.filterByOrcamento(gto))
                .map(this.renderCardItem)}
            </ul>
          ) : (
              <div className="list">{gtosList.map(this.renderCardItem)}</div>
            )}
        </div>
      );
  }
}

GuidesListing.defaultProps = {
  gtosList: []
};

GuidesListing.propTypes = {
  gtosList: PropTypes.arrayOf(PropTypes.any),
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired
};

const mapStateToProps = store => ({ gtosList: store.gto.gtosList });

export default connect(mapStateToProps)(GuidesListing);
